import { render, staticRenderFns } from "./tmsDetail.vue?vue&type=template&id=180dbb9a&scoped=true"
import script from "./tmsDetail.vue?vue&type=script&lang=js"
export * from "./tmsDetail.vue?vue&type=script&lang=js"
import style0 from "./tmsDetail.vue?vue&type=style&index=0&id=180dbb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180dbb9a",
  null
  
)

export default component.exports